function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Import modules socle
// import {isStyleSupported} from 'integration-web-core--socle/js/assets/modules/_isStyleSupported.js';
//import ResizeObserver from './includes/_resizeObserver.polyfill.min';
var StoreTypology = /*#__PURE__*/function (_lm$Composant) {
  function StoreTypology(id) {
    var _this;
    _classCallCheck(this, StoreTypology);
    _this = _callSuper(this, StoreTypology, [id]);
    // Init code
    var DOM = {
      tabsNav: document.querySelector('.js-tabs-nav-container'),
      tabsNavItems: document.querySelectorAll('.js-tabs-nav-item'),
      panelsContainer: document.querySelector('.js-tabs-panels'),
      panels: document.querySelectorAll('.js-tabs-panel'),
      access: document.querySelector('.js-access-link-itinary')
    };
    var tablist = document.querySelectorAll('[role="tablist"]')[0];
    var tabs;
    var panels;
    var delay = determineDelay();
    var i = 0;
    generateArrays();
    function generateArrays() {
      tabs = document.querySelectorAll('[role="tab"]');
      panels = document.querySelectorAll('[role="tabpanel"]');
    }

    // For easy reference
    var keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      "delete": 46
    };

    // Add or substract depending on key pressed
    var direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1
    };

    // Bind listeners
    for (i = 0; i < tabs.length; ++i) {
      addListeners(i);
    }
    function addListeners(index) {
      tabs[index].addEventListener('click', clickEventListener);
      tabs[index].addEventListener('keydown', keydownEventListener);
      tabs[index].addEventListener('keyup', keyupEventListener);

      // Build an array with all tabs (<button>s) in it
      tabs[index].index = index;
    }

    // When a tab is clicked, activateTab is fired to activate it
    function clickEventListener(event) {
      var tab = event.target;
      activateTab(tab, false);
    }

    // Handle keydown on tabs
    function keydownEventListener(event) {
      var key = event.keyCode;
      switch (key) {
        case keys.end:
          event.preventDefault();
          // Activate last tab
          activateTab(tabs[tabs.length - 1]);
          break;
        case keys.home:
          event.preventDefault();
          // Activate first tab
          activateTab(tabs[0]);
          break;

        // Up and down are in keydown
        // because we need to prevent page scroll >:)
        case keys.up:
        case keys.down:
          determineOrientation(event);
          break;
      }
    }

    // Handle keyup on tabs
    function keyupEventListener(event) {
      var key = event.keyCode;
      switch (key) {
        case keys.left:
        case keys.right:
          determineOrientation(event);
          break;
      }
    }

    // When a tablistâ€™s aria-orientation is set to vertical,
    // only up and down arrow should function.
    // In all other cases only left and right arrow function.
    function determineOrientation(event) {
      var key = event.keyCode;
      var vertical = tablist.getAttribute('aria-orientation') === 'vertical';
      var proceed = false;
      if (vertical) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else {
        if (key === keys.left || key === keys.right) {
          proceed = true;
        }
      }
      if (proceed) {
        switchTabOnArrowPress(event);
      }
    }

    // Either focus the next, previous, first, or last tab
    // depening on key pressed
    function switchTabOnArrowPress(event) {
      var pressed = event.keyCode;
      var x = 0;
      for (x = 0; x < tabs.length; x++) {
        tabs[x].addEventListener('focus', focusEventHandler);
      }
      if (direction[pressed]) {
        var target = event.target;
        if (target.index !== undefined) {
          if (tabs[target.index + direction[pressed]]) {
            tabs[target.index + direction[pressed]].focus();
          } else if (pressed === keys.left || pressed === keys.up) {
            focusLastTab();
          } else if (pressed === keys.right || pressed === keys.down) {
            focusFirstTab();
          }
        }
      }
    }

    // Activates any given tab panel
    function activateTab(tab, setFocus) {
      setFocus = setFocus || true;
      // Deactivate all other tabs
      deactivateTabs();

      // Remove tabindex attribute
      tab.removeAttribute('tabindex');

      // Set the tab as selected
      tab.setAttribute('aria-selected', 'true');

      // Get the value of aria-labelledby (which is an ID)
      var controls = tab.getAttribute('aria-controls');

      // Remove hidden attribute from tab panel to make it visible
      document.getElementById(controls).removeAttribute('hidden');

      // Set focus when required
      if (setFocus) {
        tab.focus();
        tabsNavigation(tab);
      }
    }

    // Deactivate all tabs and tab panels
    function deactivateTabs() {
      var t = 0;
      for (t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute('tabindex', '-1');
        tabs[t].setAttribute('aria-selected', 'false');
        tabs[t].removeEventListener('focus', focusEventHandler);
      }
      var p = 0;
      for (p = 0; p < panels.length; p++) {
        panels[p].setAttribute('hidden', 'hidden');
      }
    }

    // Make a guess
    function focusFirstTab() {
      tabs[0].focus();
    }

    // Make a guess
    function focusLastTab() {
      tabs[tabs.length - 1].focus();
    }

    // Determine whether there should be a delay
    // when user navigates with the arrow keys
    function determineDelay() {
      var hasDelay = tablist.hasAttribute('data-delay');
      var delay = 0;
      if (hasDelay) {
        var delayValue = tablist.getAttribute('data-delay');
        if (delayValue) {
          delay = delayValue;
        } else {
          // If no value is specified, default to 300ms
          delay = 300;
        }
      }
      return delay;
    }

    //
    function focusEventHandler(event) {
      var target = event.target;
      setTimeout(checkTabFocus, delay, target);
    }

    // Only activate tab on focus if it still has focus after the delay
    function checkTabFocus(target) {
      var focused = document.activeElement;
      if (target === focused) {
        activateTab(target, false);
      }
    }

    //set active nav element
    var setActiveItem = function setActiveItem(elem) {
      var suffix = getSuffix();
      DOM.tabsNavItems.forEach(function (el) {
        el.classList.remove('js-active' + suffix);
        el.tabIndex = -1;
      });
      elem.classList.add('js-active' + suffix);
      elem.tabIndex = 0;
    };

    //find active nav element
    var findActiveItem = function findActiveItem() {
      var suffix = getSuffix();
      var activeIndex = 0;
      for (var _i = 0; _i < DOM.tabsNavItems.length; _i++) {
        if (DOM.tabsNavItems[_i].classList.contains('js-active' + suffix)) {
          activeIndex = _i;
          break;
        }
      }
      return activeIndex;
    };
    var findLastActiveItem = function findLastActiveItem() {
      var suffix = getSuffix();
      var lastActiveIndex = 0;
      for (var _i2 = 0; _i2 < DOM.tabsNavItems.length; _i2++) {
        if (DOM.tabsNavItems[_i2].classList.contains('js-active' + suffix)) {
          lastActiveIndex = _i2;
          break;
        }
      }
      return lastActiveIndex;
    };

    //find active nav elements parameters: left coord, width
    var findActiveItemParams = function findActiveItemParams(activeItemIndex) {
      var activeTab = DOM.tabsNavItems[activeItemIndex];
      //width of elem
      var activeItemWidth = activeTab.offsetWidth - 1;
      //left coord in the tab navigation
      var activeItemOffset_left = activeTab.offsetLeft;
      return [activeItemWidth, activeItemOffset_left];
    };

    //appending decoration block to an active nav element
    var appendDecorationNav = function appendDecorationNav() {
      var suffix = getSuffix();
      //creating decoration element
      var decorationElem = document.createElement('div');
      decorationElem.classList.add('km-tabs__nav--decoration' + suffix);
      decorationElem.classList.add('js-decoration');
      //appending decoration element to navigation
      DOM.tabsNav.append(decorationElem);
      //appending styles to decoration element
      return decorationElem;
    };

    //appending styles to decoration nav element
    var styleDecorElem = function styleDecorElem(elem, decorWidth, decorOffset) {
      elem.style.width = "".concat(decorWidth, "px");
      elem.style.transform = "translateX(".concat(decorOffset, "px)");
    };

    //find active panel
    var findActivePanel = function findActivePanel(index) {
      return DOM.panels[index];
    };

    //set active panel class
    var setActivePanel = function setActivePanel(index) {
      var suffix = getSuffix();
      DOM.panels.forEach(function (el) {
        el.classList.remove('js-active' + suffix);
      });
      DOM.panels[index].classList.add('js-active' + suffix);
    };
    var getSuffix = function getSuffix() {
      var storeTypology = document.querySelector("[data-selectorid=\"component-storetypology\"]");
      return storeTypology.getAttribute("data-suffix");
    };
    var leftElem = function leftElem(target, outer) {
      outer.scrollLeft = target.offsetLeft - 40;
    };
    var rightElem = function rightElem(target, outer) {
      outer.scrollLeft = target.offsetLeft - (window.innerWidth - target.offsetWidth);
    };
    var storeDataset = document.getElementById('cartridge-store').dataset;
    var storeId = storeDataset.storeId;

    //write in session storage the id of the store consulted.
    DOM.access.addEventListener('click', function (e) {
      e.preventDefault();
      lm.localStorageLM.set('id', storeId, 1, 'sessionStorage', 'storeSpaceId');
      window.location.href = e.target.href;
    });

    //click nav item function
    DOM.tabsNav.addEventListener('mouseDown', function (e) {
      if (e.target.tagName === 'BUTTON') {
        tabsNavigation(e.target);
      } else {
        return;
      }
    });

    // Critizr Event for Bricoman
    DOM.panels.forEach(function (panel) {
      var storeContactButton = panel.querySelector(".js-store-contact-button");
      storeContactButton === null || storeContactButton === void 0 || storeContactButton.addEventListener('click', function (e) {
        e.preventDefault();
        window.CritizrSDK && window.CritizrSDK.open("modal:send_feedback", Number(storeId));
      });
    });
    var tabsNavigation = function tabsNavigation(button) {
      var navElemClass = 'js-tabs-nav-item';
      //check if we click on a nav item
      if (button.classList.contains(navElemClass)) {
        var clickedTab;
        if (button.target !== undefined) {
          clickedTab = button.target;
        } else clickedTab = button;
        var activeItemIndex = Array.from(DOM.tabsNavItems).indexOf(clickedTab);

        //find last active nav item
        var lastActiveItem = findLastActiveItem();

        //set active nav item
        setActiveItem(clickedTab);

        //find active nav item
        var activeItem = findActiveItem();

        //find active nav item params
        var _findActiveItemParams = findActiveItemParams(activeItem),
          _findActiveItemParams2 = _slicedToArray(_findActiveItemParams, 2),
          decorWidth = _findActiveItemParams2[0],
          decorOffset = _findActiveItemParams2[1];
        //setting styles to the decoration elem
        var decorElem = document.querySelector('.js-decoration');
        styleDecorElem(decorElem, decorWidth, decorOffset);
        if (clickedTab.id.substring(9) > lastActiveItem) {
          leftElem(clickedTab, DOM.tabsNav);
        } else if (clickedTab.id.substring(9) === 0) {
          DOM.tabsNav.scrollLeft = 0;
        } else {
          rightElem(clickedTab, DOM.tabsNav);
        }
        //find active panel
        findActivePanel(activeItemIndex);
        //set active panel
        setActivePanel(activeItemIndex);
      }
    };
    var resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function () {
        //find active nav item
        var activeItemIndex = findActiveItem();
        //find active nav item params
        var _findActiveItemParams3 = findActiveItemParams(activeItemIndex),
          _findActiveItemParams4 = _slicedToArray(_findActiveItemParams3, 2),
          decorWidth = _findActiveItemParams4[0],
          decorOffset = _findActiveItemParams4[1];
        var decorElem;
        if (!DOM.tabsNav.querySelector('.js-decoration')) {
          //appending decoration element to an active elem
          decorElem = appendDecorationNav();
        } else {
          decorElem = document.querySelector('.js-decoration');
        }
        //setting styles to the decoration elem
        styleDecorElem(decorElem, decorWidth, decorOffset);
        //find active panel
        findActivePanel(activeItemIndex);
        //set active panel
        setActivePanel(activeItemIndex);
      });
    });
    resizeObserver.observe(DOM.tabsNav);
    return _this;
  }
  _inherits(StoreTypology, _lm$Composant);
  return _createClass(StoreTypology);
}(lm.Composant);
lm.DOMReady(function () {
  var StoreTypologyComponent = new StoreTypology('storetypology');
});